package com.heelion.farmafreelance.voice

import androidx.compose.runtime.Composable

@Composable
actual fun rememberVoiceSpeaker(): VoiceSpeaker = WebVoiceSpeaker

/** Web Speech API (speechSynthesis): supportata da tutti i browser principali. Nessun costo. */
private object WebVoiceSpeaker : VoiceSpeaker {
    /** Nome della voce scelta dall'utente; null = automatica (maschile italiana se c'è). */
    private var scelta: String? = null

    init {
        // Il browser carica l'elenco delle voci in modo asincrono: chiederlo subito fa sì che anche
        // la prima frase di Farmy trovi la voce giusta invece di quella predefinita.
        js("if (typeof window !== 'undefined' && 'speechSynthesis' in window) window.speechSynthesis.getVoices()")
    }

    override fun isAvailable(): Boolean = js(
        "typeof window !== 'undefined' && 'speechSynthesis' in window"
    ) as Boolean

    override fun speak(testo: String, accoda: Boolean) {
        if (!isAvailable()) return
        val frase = testoPerVoce(testo)
        val interrompi = !accoda
        val tonalita = TONALITA_VOCE
        val velocita = VELOCITA_VOCE
        val regexMaschili = REGEX_VOCI_MASCHILI_WEB
        val regexQualita = REGEX_VOCI_QUALITA_WEB
        val preferita = scelta ?: ""
        js(
            """
            (function () {
                var re = new RegExp(regexMaschili, 'i');
                var qu = new RegExp(regexQualita, 'i');
                var voci = window.speechSynthesis.getVoices().filter(function (v) {
                    return v.lang && v.lang.toLowerCase().indexOf('it') === 0;
                });
                var buona = function (v) { return !v.localService || qu.test(v.name); };
                var maschile = function (v) { return re.test(v.name) && !/female/i.test(v.name); };
                // Ordine: scelta dall'utente, maschile di qualità, qualunque voce di qualità, maschile locale.
                var voce = voci.find(function (v) { return v.name === preferita; })
                    || voci.find(function (v) { return buona(v) && maschile(v); })
                    || voci.find(buona)
                    || voci.find(maschile);
                var u = new SpeechSynthesisUtterance(frase);
                u.lang = 'it-IT';
                u.pitch = (voce && buona(voce)) ? 1.0 : tonalita;
                u.rate = velocita;
                if (voce) u.voice = voce;
                if (interrompi) window.speechSynthesis.cancel();
                window.speechSynthesis.speak(u);
            })()
            """
        )
    }

    override fun stop() {
        if (isAvailable()) js("window.speechSynthesis.cancel()")
    }

    override fun voci(): List<VoceDisponibile> {
        if (!isAvailable()) return emptyList()
        val nomi = js(
            """
            window.speechSynthesis.getVoices()
                .filter(function (v) { return v.lang && v.lang.toLowerCase().indexOf('it') === 0; })
                .map(function (v) { return v.name + (v.localService ? '' : '\u0001'); })
                .join('\n')
            """
        ) as String
        return etichetteVociWeb(nomi)
    }

    override fun usaVoce(id: String?) {
        scelta = id
    }

    override fun voceScelta(): String? = scelta
}
